export default {
  sizes: {
    sm: {
      field: {
        borderRadius: 0,
        color: 'black',
        fontSize: 'xs',
        fontWeight: 'regular',
      },
    },
    md: {
      field: {
        borderRadius: 0,
        color: 'black',
        fontSize: 'sm',
        fontWeight: 'regular',
      },
    },
  },
}
